import type React from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';
import { t } from 'i18next';

interface TablePageSizeProps {
    pageSize: number;
    onPageSizeChange: (pageSize: number) => void;
}

const useStyles = makeStyles({
    pageSizeContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        height: '32px',
    },
    pageSizeSelect: {
        height: '32px',
        padding: '4px 8px',
        border: `1px solid ${tokens.colorNeutralStroke2}`,
        borderRadius: tokens.borderRadiusMedium,
        backgroundColor: tokens.colorNeutralBackground1,
        cursor: 'pointer',
        minWidth: '70px',
    },
    label: {
        color: tokens.colorNeutralForeground3,
        fontSize: tokens.fontSizeBase300,
        whiteSpace: 'nowrap',
    },
});

const TablePageSize = ({ pageSize, onPageSizeChange }: TablePageSizeProps): React.JSX.Element => {
    const classes = useStyles();

    return (
        <div className={classes.pageSizeContainer}>
            <span className={classes.label}>{t('datatable.rowsPerPage')}</span>
            <select
                className={classes.pageSizeSelect}
                value={pageSize}
                onChange={(e) => {
                    onPageSizeChange(parseInt(e.target.value, 10));
                }}
            >
                {[10, 25, 50, 100].map((size) => (
                    <option key={size} value={size}>
                        {size}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default TablePageSize;
